import { postExternalPayment, postZeroPayment } from "../../../../app/api/exchangeOffer";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { uuid } from "../../../../core/utils/Uuid";
import { STORAGE_KEYS } from "../../../../Lib/Constants/storageKeys";
import { PaymentTypeEnum } from "../../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IExternalPaymentRequest, IZeroPaymentRequest } from "../../../../Orchestrator/Types/Interface/IPayment";
import { IQuickExchangePaymentProcessActionParams } from "../../../../Orchestrator/Types/Interface/IPaymentProcess";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export class QuickExchangePaymentProcessAction extends BaseAction<string, IQuickExchangePaymentProcessActionParams> {
  protected override deduplicate = true;

  override async run(): Promise<string> {
    try {
      const { bookingId, exchangeOffersIds, total } = this.params!;
      // Clear stale trip selection data so the details page shows the full booking
      updateRecoilState("selectedTripsDataAtom", null);

      if (total > 0) {
        const payload: IExternalPaymentRequest = {
          paidAmount: {
            currency: "AED",
            amount: total,
            scale: 0
          },
          transactionId: uuid(),
          typeId: PaymentTypeEnum.SalesPointePaymentCard,
          offerPartIds: exchangeOffersIds
        }
        const preExchangeResponse: any = await postExternalPayment(payload, bookingId)
        if (preExchangeResponse.status === 'ok' && preExchangeResponse.answer) {

        }
      }
      if (total === 0) {
        const payload: IZeroPaymentRequest = {
          offerPartIds: exchangeOffersIds
        }
        const preExchangeResponse: any = await postZeroPayment(payload, bookingId)
        if (preExchangeResponse.status === 'ok' && preExchangeResponse.answer) {

        }
      }

    } catch (error) {
      console.error("Error during payment type change:", error);
    } finally {
      if (typeof window !== "undefined") {
        localStorage.removeItem(STORAGE_KEYS.CHANGE_DATE_FLOW);
        localStorage.removeItem("isChangeDateFlowForToast");
      }
      return ""
    }
  }
}

export const quickExchangePaymentProcessAction = new QuickExchangePaymentProcessAction();
